<template>
    <div class="canvas-stage-mission" :class="{locked}">
        <div class="content">
            <div class="mission-actions">
                <div class="item">
                    <h4>Stage At-A-Glance</h4>
                    <markdown-text v-if="mission.description" :content="mission.description"/>
                </div>
                <div class="item">
                    <h4>Student's Stage Mission</h4>
                    <markdown-text v-if="mission.deliverable" :content="mission.deliverable"/>
                </div>

            </div>
        </div>

    </div>
</template>

<script>
import MarkdownText from "@/Components/Common/MarkdownText";
import {mapActions} from "vuex";
import utils from "@/mixins/utils";

export default {
    name: "StageMission",
    components: {MarkdownText},
    props: ['path', 'canvas', 'stage', 'locked', 'project'],
    emits: ['deliverable'],
    mixins: [utils],

    data(){
        return {
        }
    },

    computed: {

        path_fragment_key(){
            return `stage_${this.stage}_misson_details`;
        },

        mission: {
            get(){
                if( typeof this.path.fragments[ this.path_fragment_key ] !== 'undefined' ){
                    return this.path.fragments[ this.path_fragment_key ];
                }
                return {};
            },

            set(val){
                this.path.fragments[ this.path_fragment_key ] = val;
            }
        },

    },

    methods: {
        ...mapActions('repositories', {
            updateRepo: 'updateRepository',
        }),
    },


    mounted() {
    }

}
</script>

<style lang="scss" scoped>
.canvas-stage-mission{
    border: darken($light-borders, 5%) solid 1px;
    border-radius: 0.65rem;
    padding-top: 2rem;
    margin-bottom: 2rem;

    .content{
        h4{
            font-weight: $font-weight-normal;
            font-size: 0.9rem;
            margin-bottom: 0.6rem;
            text-transform: uppercase;

            span{
                font-style: italic;
                text-transform: none;
            }
        }

        p{
            font-weight: $font-weight-semibold;
            font-size: 1rem;
        }
    }
}

.mission-actions{
    .item {
        margin-bottom: 2rem;
        padding: 0 1.5rem;
    }
}

.locked{
    background: lighten($danger, 40%);
}
</style>
